import createRequest from '../core/request'

/**
 * 管理-首页基本信息
 * @param {*} params
 * @returns
 */
export function get_admin_info(params) {
  return createRequest('CORPAPI').get('/admin/admin_info', {
    params
  })
}

/**
 * 管理-修改权限
 * @param {*} params
 * @returns
 */
export function set_admin_corp_info(params, data) {
  return createRequest('CORPAPI').post('/admin/set_corp_info', data, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params
  })
}

/**
 * 修改部分公司信息（老接口）
 * @link http://192.168.20.80/webapi/#452-en
 * @param {*} params
 * @returns
 */
export function set_corp_info_old(params, data) {
  return createRequest('CORPAPI').post('/set_corp_info', data, {
    headers: {
      'Content-Type': 'text/plain'
    },
    params
  })
}

/**
 * 管理-获取权限设置
 * @param {*} params
 * @returns
 */
export function get_account_permission(params) {
  return createRequest('CORPAPI').get('/admin/account_permission', {
    params
  })
}

/**
 * 管理-设置可以编辑的所有员工
 * @param {*} params
 * @returns
 */
export function set_edit_limit(params, data) {
  return createRequest('CORPAPI').post('/admin/batch_set_userinfo', data, {
    params
  })
}

/**
 * 管理-设置同步到个人版
 * @param {*} params
 * @returns
 */
export function set_personal_sync(params, data) {
  return createRequest('CORPAPI').post('/admin/set_user_personal_sync', data, {
    params
  })
}

/**
 * 管理-编辑员工权限列表
 * @param {*} params
 * @returns
 */
export function get_account_edit_list(params) {
  return createRequest('CORPAPI').get('/admin/account_edit_list', {
    params
  })
}

/**
 * 管理-部门架构图
 * @param {*} params
 * @returns
 */
export function get_department_tree(params) {
  return createRequest('CORPAPI').get('/admin/department_tree', {
    params
  })
}

/**
 * 管理-设置部门
 * @param {*} params
 * @returns
 */
export function set_department_info(params, data) {
  return createRequest('CORPAPI').post('/admin/set_department_info', data, {
    params
  })
}

/**
 * 管理-添加部门
 * @param {*} params
 * @returns
 */
export function create_department(params, data) {
  return createRequest('CORPAPI').post('/admin/create_department', data, {
    params
  })
}

/**
 * 管理-获取部门信息
 * @param {*} params
 * @returns
 */
export function get_department_info(params, data) {
  return createRequest('CORPAPI').post('/admin/department_info', data, {
    params
  })
}

/**
 * 管理-删除部门
 * @param {*} params
 * @returns
 */
export function remove_department(params) {
  return createRequest('CORPAPI').get('/admin/remove_department', {
    params
  })
}

/**
 * 管理-crm 配置
 * @param {*} params
 * @returns
 */
export function set_department_crm(params) {
  return createRequest('CORPAPI').get('/admin/department_crm', {
    params
  })
}

/**
 * 管理- 员工管理
 * @param {*} params
 * @returns
 */
export function get_members_list(params) {
  return createRequest('CORPAPI').get('/admin/get_members_list', {
    params
  })
}

/**
 * 管理- 操作员工信息
 * @param {*} params
 * @returns
 */
export function set_members_info(params, data) {
  return createRequest('CORPAPI').post('/admin/set_user_info', data, {
    params
  })
}

/**
 * 管理- 未加入员工操作员工信息
 * @param {*} params
 * @returns
 */
export function set_inviter_info(params, data) {
  return createRequest('CORPAPI').post('/admin/set_invitee_info', data, {
    params
  })
}

/**
 * 管理- 设置接任者
 * @param {*} params
 * @returns
 */
export function set_members_successor(params) {
  return createRequest('CORPAPI').get('/admin/set_user_successor', {
    params
  })
}

/**
 * 管理- 邀请链接
 * @param {*} params
 * @returns
 */
export function get_invite_link(params) {
  return createRequest('CORPAPI').get('/admin/get_invite_link', {
    params
  })
}

/**
 * 管理- 设置为离职
 * @param {*} params
 * @returns
 */
export function set_demission_account(params, data) {
  return createRequest('CORPAPI').post('/admin/demission_account', data, {
    params
  })
}

/**
 * 管理- 取消邀请
 * @param {*} params
 * @returns
 */
export function set_cancel_invite(params, data) {
  return createRequest('CORPAPI').post('/admin/set_invitee_info', data, {
    params
  })
}

/**
 * 管理- 重新邀请
 * @param {*} params
 * @returns
 */
export function set_reinvite(params, data) {
  return createRequest('CORPAPI').post('/admin/invite', data, {
    params
  })
}

/**
 * 管理-下载员工账号 excel
 * @param {*} params
 * @returns
 */
export function export_account_excel(params) {
  return createRequest('CORPAPI').get('/admin/export_account_excel', {
    params
  })
}

/**
 * crm- 绑定
 * @param {*} params
 * @returns
 */
export function bind_crm(params, data) {
  return createRequest('SyncAPI').post('/bind_crm', data, {
    params
  })
}

/**
 * crm- 解除绑定
 * @param {*} params
 * @returns
 */
export function remove_bind_crm(params) {
  return createRequest('SyncAPI').get('/crm_unbind', {
    params
  })
}

/**
 * google- 获取初始化状态
 * @param {*} params
 * @returns
 */
export function get_google_contact(params) {
  return createRequest('CORPAPI').get('/admin/get_google_config', {
    params
  })
}

/**
 * google- 开启关闭
 * @param {*} params
 * @returns
 */
export function set_google_config(params, data) {
  return createRequest('CORPAPI').post('/admin/set_google_config', data, {
    params
  })
}

/**
 * 安全设置- 获取状态
 * @param {*} params
 * @returns
 */
export function get_security_status(params) {
  return createRequest('CORPAPI').get('/admin/security_status', {
    params
  })
}

/**
 * 安全设置- 设置状态
 * @param {*} params
 * @returns
 */
export function set_security_status(params, data) {
  return createRequest('CORPAPI').post('/admin/set_security_status', data, {
    params
  })
}

/**
 * 安全设置- 获取ip列表
 * @param {*} params
 * @returns
 */
export function get_security_ip_list(params) {
  return createRequest('CORPAPI').get('/admin/ip_limit_list', {
    params
  })
}

/**
 * 安全设置-操作IP
 * @param {*} params
 * @returns
 */
export function ip_limit_modify(params, data) {
  return createRequest('CORPAPI').post('/admin/ip_limit_modify', data, {
    params
  })
}

/**
 * 安全设置- 添加ip
 * @param {*} params
 * @returns
 */
export function add_security_ip(params, data) {
  return createRequest('CORPAPI').post('/admin/add_security_ip', data, {
    params
  })
}

/**
 * 安全设置- 删除ip
 * @param {*} params
 * @returns
 */
export function remove_security_ip(params, data) {
  return createRequest('CORPAPI').post('/admin/remove_security_ip', data, {
    params
  })
}

/**
 * 安全设置- 获取device列表
 * @param {*} params
 * @returns
 */
export function get_security_device_list(params) {
  return createRequest('CORPAPI').get('/admin/device_limit_list', {
    params
  })
}

/**
 * 安全设置-操作device设备
 * @param {*} params
 * @returns
 */
export function device_limit_modify(params, data) {
  return createRequest('CORPAPI').post('/admin/device_limit_modify', data, {
    params
  })
}

/**
 * 安全设置-导出device excel
 * @param {*} params
 * @returns
 */
export function export_device_excel(params) {
  return createRequest('CORPAPI').get('/admin/export_device_excel', {
    params
  })
}

/**
 * 设置公司id
 */
export function set_corp_unique_id(params, data) {
  return createRequest('CORPAPI').post('/admin/set_corp_unique_id', data, {
    params
  })
}

/**
 * @link http://192.168.20.80/webapi/#1053-en
 * @description 超管或管理员给账号以 .ccb 结尾的员工重置密码
 * @returns {*}
 */
export function set_member_password(getParams = {}) {
  return createRequest('CORPAPI').get('/set_member_password', {
    params: getParams
  })
}

/**
 * 管理- outlook通讯录配置
 * 2023/4/19 web34 一期
 */

/**
 * outlook- 获取初始化状态 *TODO
 * @param {*} params
 * @returns
 */
export function get_outlook_contact(params) {
  return createRequest('CORPAPI').get('/admin/get_outlook_config', {
    params
  })
}

/**
 * outlook- 开启关闭 *TODO
 * @param {*} params
 * @returns
 */
export function set_outlook_config(params, data) {
  return createRequest('CORPAPI').post('/admin/set_outlook_config', data, {
    params
  })
}

/**
 * 设置企业信息
 * https://web-api.intsig.net/project/613/interface/api/154233
 * @param {*} params
 * @returns
 */
export function add_corp_info(params, data) {
  return createRequest('CORPAPI').post('/add_corp_info', data, {
    params
  })
}
